import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

import { CSVReportResponse } from "services/types/reports.type";

export type CSVReport = CSVReportResponse & {
  isReady: boolean;
};

type ReportDownloadBannerProps = {
  csvReport: CSVReport;
  closeReport?: () => void;
  reportName?: string;
};
export default function ReportDownloadBanner({
  csvReport,
  closeReport,
  reportName
}: ReportDownloadBannerProps) {
  const title =
    "csv_title" in csvReport ? csvReport.csv_title : csvReport.xlsx_title;
  const url =
    "csv_title" in csvReport
      ? csvReport.csv_download_url
      : csvReport.xlsx_download_url;

  return (
    <Alert
      severity="success"
      onClose={closeReport}
      action={
        csvReport.isReady && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Link href={url} download={title} underline="hover">
              Download
            </Link>
          </Box>
        )
      }
      sx={{ alignItems: "center" }}
    >
      {csvReport.isReady ? (
        <AlertTitle sx={{ mb: 0 }}>
          Your "{reportName || title}" report is ready to be downloaded.
        </AlertTitle>
      ) : (
        <>
          <AlertTitle sx={{ mb: 0 }}>Preparing Your Report</AlertTitle>
          Your report is being prepared. You will receive a notification in the
          top-right corner when it's ready for download. Feel free to leave this
          page in the meantime. Thank you for your patience!
        </>
      )}
    </Alert>
  );
}
